module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_17.5e63eab9.mp3";